module.exports = __webpack_public_path__ + "static/img/6areaB_2.d44aea3.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/6areaB_2.png
// module id = 1205
// module chunks = 1